<template>
    <div> 
        <div class="inner-banner-custom justify-content-center row align-items-center mb-3">
            <div class="left-block  text-center middleBox">
                <h2 class="mb-3"> {{$t('ecoCalendar')}}</h2>
                <p>{{$t('ecoCal_Title_Txt')}}</p> 
            </div> 
        </div>
        <!-- <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader && eventIndex == ''"></complete-loading> -->
        <div class="events-filter d-flex align-items-center justify-content-between flex-wrap mb-2"><!-- {{date}} -->
            <div class="d-flex align-items-center justify-content-between flex-wrap">
                <div class="filter_one selextDuDate d-flex align-items-center">
                    <div class="customFilter-btn px-2 py-1 border-radius d-inline-flex align-items-center">
                        <a href="#" @click.prevent="DateChanged('1')">
                            <feather size="16px" type="chevron-left"></feather> 
                        </a>
                        <datepicker class=" " v-model="date" placeholder="Select Date" ref="datepicker" range-separator="To" :format="'DD MMMM YYYY'" :shortcuts="shortcuts" :lang="lang" :range="true" :disabled-date="notAfterToday" @change="dateChange()" :editable="false"></datepicker>
                        <a href="#" @click.prevent="DateChanged('3')">
                            <feather size="16px" type="chevron-right"></feather> 
                        </a>
                    </div>
                </div>
            </div>
           
            <div class="search_five">
                <div class="upNext d-flex align-items-center">
                    <a class="customFilter-btn mr-2 px-3 py-2 border-radius d-inline-flex align-items-center" href="#" @click.prevent="upNext()">{{$t('ecoCal_Up_next')}} <feather class="left triangle" size="14px" type="triangle"></feather></a>
                    <div class="flagFilter">
                        <a @click.prevent="currencyFilter = !currencyFilter" :class="(currencyFilter)?'active':''" class="customFilter-btn padAus border-radius d-flex currencyFilter" href="#"><feather size="16px" type="filter"></feather>
                        </a>
                        <div :class="(currencyFilter)?'active':''" class="animateDorp mt-2 currencyFilter" style="z-index: 2">

                            <div class="filterTitle d-flex align-items-center justify-content-between mb-3">
                                <h3 class="d-flex align-items-center mb-0">{{$t('ecoCal_Country')}} <a class="green seleClear" href="#" @click.prevent="selectAll()">{{$t('ecoCal_Select_All')}}</a>/ <a class="red seleClear" href="#" @click.prevent="countries = []">{{$t('ecoCal_Clear')}}</a></h3>
                                <div class="filterTab">
                                    <a class="fitSelect active" href="#">{{$t('ecoCal_My_Filter')}}</a>
                                    <a class="fitSelect" href="#">{{$t('ecoCal_Default')}}</a>
                                </div>
                            </div>
                            <!-- <div v-if="selectcountrymessage && countries.length == 0" class="red text-center">
                                {{selectcountrymessage}}
                            </div> -->
                                <div class="currencySection">
                                <label class="custom-check-box" v-for="Country in countriesList">
                                    <img :src="'../../../../../static/fxView/images/country_images/'+Country.name.toLowerCase()+'.svg'" alt="Icon"> {{Country.name}}
                                    <input type="checkbox" :value="Country.name" v-model="countries">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="sndfil mt-2">
                                <h3 class="d-flex align-items-center mb-0">{{$t('ecoCal_Impact')}}</h3>
                                <!-- <label class="custom-check-box">None
                                    <input type="radio">
                                    <span class="checkmark"></span>
                                </label> -->
                                <label class="custom-check-box"> {{$t('ecoCal_All')}}
                                    <input type="radio" value="1" v-model="priority">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box"> {{$t('ecoCal_Medium')}}
                                    <input type="radio" value="2" v-model="priority">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box"> {{$t('ecoCal_High')}}
                                    <input type="radio" value="3" v-model="priority">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <!-- <div class="sndfil mt-2">
                                <h3 class="d-flex align-items-center mb-0">Category</h3>
                                <label class="custom-check-box">Bond Auctions
                                    <input type="checkbox" checked="checked">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Capital Flows
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Central Banks
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Consumption
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Economic Activity
                                    <input type="checkbox" checked="checked">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Energy
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Holidays
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Housing Market
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Inflation
                                    <input type="checkbox" checked="checked">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box"> Interest Rates
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box"> Labor Market
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="custom-check-box">Politics
                                    <input type="checkbox">
                                    <span class="checkmark"></span>
                                </label>
                            </div> -->
                            <div class="saveSetting d-flex align-items-center justify-content-between mt-3 pt-3 border-top">
                                <label class="custom-check-box w-50">{{$t('ecoCal_Save_filter')}}
                                    <input type="checkbox" checked="checked">
                                    <span class="checkmark"></span>
                                </label>
                                <a class="cr-btn w-auto hvr-sweep-to-top greenBG" href="#" @click.prevent="Countrywiselisting(countries)" v-if="priority == '1'">{{$t('ecoCal_Apply_Filter')}}</a>
                                <a class="cr-btn w-auto hvr-sweep-to-top greenBG" href="#" @click.prevent="loaderFuncRun = '1' ; listing(); filter_no_record = false" v-else-if="priority == '2' || priority == '3'">{{$t('ecoCal_Apply_Filter')}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="whiteBG p-3"> 
                <div class="row justify-content-center ecoCalendarResponsive">
                    <div class="col-12">
                        <!-- <div class="events-filter d-flex align-items-center justify-content-end flex-wrap">
                            <filter-component :limitFilter="'disable'" :searchFilter="'disable'" :pageTitle="pageName"></filter-component>
                        </div> -->
                        
                        <div class=" light-shadow table-responsive"> 
                            <!-- <img src="../../../../static/fxview/images/country_images/australia.svg"/> -->
                            <table class="table fundingMethodstable table-striped mainCeo-table">
                                <thead>
                                    <tr>
                                        <td colspan="11" class="p-0">
                                            <table class="inntebbel cloud">
                                                <thead>
                                                    <tr>
                										<th class="TimeArea">
                                                            <span class="timeZone-filter flagFilter">
                                                                <a @click.prevent="timeFilter = !timeFilter" class="fitlr timeFilter" href="javascript:void(0)">{{$t('ecoCal_Time')}}</a>
                                                                <div :class="(timeFilter)?'active':''" class="animateDorp mt-2 timeFilter" style="z-index: 1">
                                                                    <h3 class="mb-4 text-left">{{$t('ecoCal_TimeZ_Settings')}}</h3>
                                                                    <div class="zoneArea d-flex align-items-center justify-content-between">
                                                                        <p class="mb-0">{{$t('ecoCal_TimeZ')}}</p>
                                                                        <div class="form-group field-wrapper">
                                                                            <select class="float-field" v-model="offset" @change="autoTime = false">
                                                                              <option value="">{{$t('ecoCal_Select_TimeZ')}}</option>
                                                                              <option :value="list.val" v-for="list in timezone">{{list.text}}</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div class="zoneArea d-flex align-items-center justify-content-between">
                                                                        <p class="mb-0">{{$t('ecoCal_TimeF')}}</p>
                                                                        <div class="form-group field-wrapper amPm">
                                                                            <select class="float-field" v-model="timeFormat">
                                                                              <option value="am-pm">AM / PM</option>
                                                                              <option value="24hrs">24 hours</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div class="zoneArea d-flex align-items-center justify-content-between">
                                                                        <p class="mb-0">{{$t('ecoCal_Set_timeZ_Auto')}}</p>
                                                                        <div class="form-group field-wrapper automatically">
                                                                            <label class="switch">
                                                                              <input type="checkbox" v-model="autoTime" @change="autoTimeChange()">
                                                                              <span class="slider"></span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="saveSetting d-flex align-items-center justify-content-between mt-3 pt-3 border-top">
                                                                        <a class="cr-btn w-auto hvr-sweep-to-top greenBG" href="#" @click.prevent="timeFilter = false ">{{$t('ecoCal_Save_Sett')}}</a>
                                                                        <a class="cr-btn w-auto hvr-sweep-to-top redBG" href="#" @click.prevent="timeFilter = false ">{{$t('ecoCal_Cancel')}}</a>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </th>
                										<th class="country_flag">{{ $t('ecoCal_Country') }} </th>
                										<th class="event-name">{{ $t('ecoCal_Event') }} </th>
                                                        <th class="ImpactArea">{{$t('ecoCal_Impact')}} </th>
                										<th class="ActualArea">{{ $t('ecoCal_Actual') }} </th>
                										<th class="ForecastArea">{{ $t('ecoCal_Forecast') }}<!-- <feather type="alert-circle"/> --></th>
                										<th class="PreviousArea">{{ $t('ecoCal_Previous') }} </th>
                										<th class="PreviousArea"></th>
                									</tr>
                                                </thead>
                                            </table>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody v-if="!pageLoader && filter_no_record">
                                    <td class="animated-background text-center" colspan="8" > 
                                        {{$t('ecoCal_noRecord')}}
                                    </td>
                                </tbody>
                                <tbody v-else-if="Object.keys(economicCalData).length && ((eventIndex == '')?(!pageLoader):true)" v-for="list,key,index in economicCalData">
                                    <tr>
                                        <td colspan="8" class="p-0">
                                            <table class="inntebbel cloud">
                                                <tr class="fxs_c_period">
                                                    <td colspan="8" class="text-center green stDate">{{key | moment("dddd, DD MMMM YYYY")}}</td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr v-for="(calenderDatewise,index1) in list" :id="'calander'+index+'_'+index1" @click.prevent="getEvent(calenderDatewise.symbol,index,index1)">
                                        <td colspan="7" class="p-0">
                                            <table class="inntebbel cloud"><!--- -->
                                                <tr class="clickAbleTR">
                                                    <td class="TimeArea"> {{Getdate(calenderDatewise.date,offset,timeFormat)}}<!--  {{calenderDatewise.symbol}} --></td>
                                                    <td class="country_flag">
                                                        <img :src="'../../../../../static/fxView/images/country_images/'+calenderDatewise.country.toLowerCase()+'.svg'" class="data_currency_icon">{{calenderDatewise.country}}
                                                    </td>
                                                    <td class="event-name" v-html="(calenderDatewise.event != '' && calenderDatewise.event != null)?calenderDatewise.event : '-'"></td>
                                                    <td  class="ImpactArea">
                                                        <span :class= "priorityLabel[calenderDatewise.importance]">
                                                            <feather type="bar-chart"></feather>
                                                        </span>
                                                    </td>
                                                    <td class="ActualArea" v-html="(calenderDatewise.actual != '' && calenderDatewise.actual != null)?calenderDatewise.actual : '-'"></td>
                                                    <td class="ForecastArea" v-html="(calenderDatewise.forecast != '' && calenderDatewise.forecast != null)?calenderDatewise.forecast : '-'"></td>
                                                    <td class="PreviousArea" v-html="(calenderDatewise.previous != '' && calenderDatewise.previous != null)?calenderDatewise.previous : '-'"></td>
                                                    <td class="PreviousArea"><feather type="bell" v-if="calenderDatewise.symbol"/></td>
                                                </tr>
                                                <tr class="showDiv" v-if="eventSymbol != '' && calenderDatewise.symbol == eventSymbol && eventIndex == index+'_'+index1">
                                                    <td class="showContent" colspan="8">
                                                        <span class="innerloader"><complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading></span>
                                                        <div class="displayContent d-flex text-left" :class="[{'full-child':!(eventData.lastnews && eventData.lastnews.length) || !(eventData.chartdata && eventData.chartdata.length > 0)}]">
                                                            <div class="lefArea child" v-if="eventData.lastnews && eventData.lastnews.length">
                                                                <h3>{{eventData.lastnews[0].category || '-'}}</h3>
                                                                <p>{{eventData.lastnews[0].title || '-'}}</p>
                                                                <div class="middleContent">
                                                                    <div class="d-flex align-items-center justify-content-between">
                                                                        <h3>Frequency: Monthly</h3>
                                                                        <span class="dateFr">{{eventData.lastnews[0].date | moment('dd MMMM YYYY')}}</span>
                                                                    </div>
                                                                    <p>{{eventData.lastnews[0].description || '-'}}</p>
                                                                </div>
                                                            </div>
                                                            <div class="rightArea child">
                                                                <bar-chart :chart_data="eventData.chartdata"  v-if="eventData.chartdata && eventData.chartdata.length > 0"/>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="eventIndex == '' && (Object.keys(economicCalData).length == 0  || pageLoader)">
                                    <tr class="customtableloading" v-for="n in 7" v-if="pageLoader">
                                        <td class="animated-background"  v-for="i in 7"> 
                                            <div class="animated-background"></div>
                                        </td>
                                    </tr>
                                    <tr class="customtableloading" v-if="!pageLoader">
                                        <td class="animated-background text-center" colspan="7" > 
                                            {{$t('ecoCal_noRecord')}}
                                        </td>
                                    </tr>
                                </tbody>
                               
                                
                                <!-- <tbody v-if="economicCalData != [] && !pageLoader" v-for="list, key in economicCalData" >
									<tr class="fxs_c_period">
										<td class="text-center" colspan='6'>{{key | moment("dddd, DD MMMM YYYY")}}</td>
									</tr>
									<tr v-for="calenderDatewise in list">
										<td class="nowrap">{{calenderDatewise.Date | moment("hh:mm a")}}</td>
										<td class="d-flex align-items=center">
											<img :src="'../../../../static/fxview/images/country_images/'+calenderDatewise.Country.toLowerCase()+'.svg'"  class="data_currency_icon" /> {{calenderDatewise.Country}}
										</td>
										<td v-html="(calenderDatewise.Event != '' && calenderDatewise.Event != null)?calenderDatewise.Event : '-'"></td>
                                        <td><feather type="bar-chart" class="inColor" :class= "priorityLabel[calenderDatewise.Importance]"></feather></td>
										<td  v-html="(calenderDatewise.Actual != '' && calenderDatewise.Actual != null)?calenderDatewise.Actual : '-'"></td>
										<td v-html="(calenderDatewise.Previous != '' && calenderDatewise.Previous != null)?calenderDatewise.Previous : '-'"></td>
										<td v-html="(calenderDatewise.Forecast != '' && calenderDatewise.Forecast != null)?calenderDatewise.Forecast : '-'"></td>
									</tr>
								</tbody>
                                
								<tbody v-if="economicCalData.length == 0  && pageLoader">
									<tr class="customtableloading" v-for="n in 7" v-if="pageLoader">
										<td class="animated-background"  v-for="i in 7"> 
											<div class="animated-background"></div>
										</td>
									</tr>
									<tr class="customtableloading" v-if="!pageLoader">
										<td class="animated-background text-center" colspan="7" > 
											no record
										</td>
									</tr>
								</tbody> -->
                            </table>
                        </div>
                    </div> 
                </div>
             
        </div>

    </div>
</template>
<script> 
    import moment from 'moment'
    import barChart from '../../shared/barChart'
    import { Const } from "../../../../plugins/fxView/provider/candle-history/lib/const.cls.ts"
	export default {
		name: 'Economic-Calender',
		data() {
			return {
				pageName : this.$options.name,
				load_more_msz : false,
				//===========prop in loader component=======
				col_span : 5,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
                pageLoader1 : false,
                currencyFilter : false,
                timeFilter : false,
				loaderFuncRun : '1',
				fromDateField : '',
				toDateField : '',
				priority : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : 1,
                priorityLabel: {"1": "yellow", "2": "orange", "3": "red"},
                eventData:{},
                eventSymbol:'',
                eventIndex:'',
                timezone :[
                    {offset: 720 ,text:'UTC -12', val:'-12'},
                    {offset: 660 ,text:'UTC -11', val:'-11'},
                    {offset: 600 ,text:'UTC -10', val:'-10'},
                    {offset: 540 ,text:'UTC -9', val:'-9'},
                    {offset: 480 ,text:'UTC -8', val:'-8'},
                    {offset: 420 ,text:'UTC -7', val:'-7'},
                    {offset: 360 ,text:'UTC -6', val:'-6'},
                    {offset: 300 ,text:'UTC -5', val:'-5'},
                    {offset: 240 ,text:'UTC -4', val:'-4'},
                    {offset: 180 ,text:'UTC -3', val:'-3'},
                    {offset: 120 ,text:'UTC -2', val:'-2'},
                    {offset: 60 ,text:'UTC -1', val:'-1'},
                    {offset: 0 ,text:'UTC', val:'0'},
                    {offset: -60 ,text:'UTC +1', val:'+1'},
                    {offset: -120 ,text:'UTC +2', val:'+2'},
                    {offset: -180 ,text:'UTC +3', val:'+3'},
                    {offset: -210 ,text:'UTC +3:30', val:'+3.5'},
                    {offset: -240 ,text:'UTC +4', val:'+4'},
                    {offset: -270 ,text:'UTC +4:30', val:'+4.5'},
                    {offset: -300 ,text:'UTC +5', val:'+5'},
                    {offset: -330 ,text:'UTC +5:30', val:'+5.5'},
                    {offset: -345 ,text:'UTC +5:45', val:'+5.75'},
                    {offset: -360 ,text:'UTC +6', val:'+6'},
                    {offset: -420 ,text:'UTC +7', val:'+7'},
                    {offset: -480 ,text:'UTC +8', val:'+8'},
                    {offset: -540 ,text:'UTC +9', val:'+9'},
                    {offset: -570 ,text:'UTC +9:30', val:'+9.5'},
                    {offset: -600 ,text:'UTC +10', val:'+10'},
                    {offset: -630 ,text:'UTC +10:30', val:'+10.5'},
                    {offset: -660 ,text:'UTC +11', val:'+11'},
                    {offset: -720 ,text:'UTC +12', val:'+12'},
                    {offset: -780 ,text:'UTC +13', val:'+13'},
                    {offset: -840 ,text:'UTC +14', val:'+14'},
                ],
                offset : '',
                countries:[],
                // date:[new Date(Date.now() - 15*24 * 3600 * 1000),new Date()],
                date:[Date.now(),new Date(Date.now() + 15*24 * 3600 * 1000)],
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                    monthBeforeYear: false,
                },
                shortcuts:[
                    { text: 'Prev 15 Days', start: new Date(Date.now() - 15*24 * 3600 * 1000), end: new Date() },
                    { text: 'Prev 30 Days', start: new Date(Date.now() - 30*24 * 3600 * 1000), end: new Date() },
                    { text: 'Next 15 Days', start: new Date(), end: new Date(Date.now() + 15*24 * 3600 * 1000) },
                    { text: 'Next 30 Days', start: new Date(), end: new Date(Date.now() + 30*24 * 3600 * 1000) },
                ],
                timeFormat: 'am-pm',//24hrs
                responseData : [],
                filterdata :[],
                selectcountrymessage : '',
                filter_no_record : false,
                upnextDate: false,
                autoTime: false

			}
		},
        components:{
            barChart
        },
		methods:{
			autoTimeChange(){
				if(this.autoTime === true){
					let time = this.timezone.filter(list=>list.offset == new Date().getTimezoneOffset())
					this.offset = (time.length)?time[0].val:''
					this.timeFormat = 'am-pm'
				}
			},
            upNext(){
            	this.upnextDate = true
                this.date = [Date.now(),new Date(Date.now() + 15*24 * 3600 * 1000)]
                this.eventIndex = ''
                this.loaderFuncRun = '1'
                this.listing()
            },
			dateChange(){
				if(this.date[0],this.date[0]){
					this.$refs.datepicker.closePopup()
					this.eventIndex = ''
                    this.loaderFuncRun = '1'
                    this.listing()
                    
				}
			},
            selectAll(){
                this.countries = this.countriesList.map(val =>{
                    return val.name
                })
            },
            DateChanged(val){
                let d1 = new Date()
                let d2 = new Date()
                if(this.date[0]) d1 = new Date(this.date[0]);
                if(this.date[1]) d2 = new Date(this.date[1]);
                if(val == '1'){
                    let date0 = new Date(d1 - 15*24 * 3600 * 1000)
                    let date1 = d1
                    if(moment(d1, 'MM/DD/YYYY').isBefore(moment())){
                        return
                    }
                    else if(moment(date0, 'MM/DD/YYYY').isBefore(moment())){
                        this.date = [Date.now(),new Date(Date.now() + 15*24 * 3600 * 1000)]
                    }
                    else{
                        this.date = [date0,date1]
                    }
                }
                else if(val == '3'){
                    let date2 = d2
                    let date3 = new Date(d2.getTime()+(15*24*60*60*1000))
                    this.date = [date2,date3]
                }
                this.eventIndex = ''
                this.loaderFuncRun = '1'
                this.listing()
            },
            notAfterToday(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return date.getTime() < today.getTime();
            },
            Getdate(key,offset,timeFormat){
                let format = 'hh:mm a'
            	if(timeFormat == '24hrs') format = 'HH:mm'
            	if(timeFormat == 'am-pm') format = 'hh:mm a'

                if(offset == ''){
                	let d = new Date(key);
                    return moment(d.toString()).format(format)
                }else{
                    let d = new Date(key);
                    let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
                    let nd = new Date(utc + (3600000*offset));
                    return moment(nd).format(format)
                }
            },
			/*countryName(getData){
				if(getData != '' && getData != null){
					
				}else{
					return '-';
				}
			},*/
            listing(){
                let from = moment(this.date[0]).format("YYYY-MM-DD")
                let to = moment(this.date[1]).format("YYYY-MM-DD")
                let inputJson = {
                    'globalParams' : {
                        filter: {'from':from.toString() ,'to':to.toString(),'priority':this.priority,'countries':this.countries },
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                        offset : (new Date().getTimezoneOffset()),
                    } ,
                    'localParams' : {'parameter' : this,'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetEconomicCalData(inputJson)
            },
            Countrywiselisting(getcountry){
                if(getcountry.length > 0 && this.responseData.length > 0){
                    this.currencyFilter = false
                    let auto_chartist = {};
                    for(let i=0; i<=getcountry.length-1; i++){
                        for(let j=0; j<=this.responseData.length-1; j++){
                            if(this.responseData[j].Country == getcountry[i]){
                                // this.filterdata.push(this.responseData[j])
                                let d = new Date(this.responseData[j].Date);
                                const eventDate = moment(d).format("YYYY-MM-DD")
                                if(this.upnextDate){
                                    if(Date.parse(responseData[j].Date) < Date.now().toString()){
                                        continue;
                                    }
                                }
                                if(auto_chartist[eventDate]){
                                    auto_chartist[eventDate].push(this.responseData[j])
                                }else{
                                    auto_chartist[eventDate] = []
                                    auto_chartist[eventDate].push(this.responseData[j])
                                }
                            }
                            if(i == getcountry.length-1){
                                if(Object.keys(auto_chartist).length > 0){
                                    this.filter_no_record = false
                                    this.$store.commit(Const.SET_ECONOMIC_CALENDER_DATA, auto_chartist)
                                    if(this.upnextDate){
                                        this.upnextDate = false
                                    }
                                }else{
                                    this.filter_no_record = true
                                }
                            }
                        }
                        /*console.log(this.filterdata.length,'filterdata',this.filterdata)
                        if(i == getcountry.length-1){
                            if(this.filterdata.length > 0){
                                this.filter_no_record = false
                                for(let k=0 ; k<=this.filterdata.length-1 ; k++){
                                    let d = new Date(this.filterdata[k].Date);
                                    const eventDate = moment(d).format("YYYY-MM-DD")
                                    if(this.upnextDate){
                                        if(Date.parse(filterdata[k].Date) < Date.now().toString()){
                                            continue;
                                        }
                                    }
                                    if(auto_chartist[eventDate]){
                                        auto_chartist[eventDate].push(this.filterdata[k])
                                    }else{
                                        auto_chartist[eventDate] = []
                                        auto_chartist[eventDate].push(this.filterdata[k])
                                    }
                                    if(k == this.filterdata.length-1){
                                        console.log('=====autochartttttttttt',auto_chartist)
                                        this.$store.commit(Const.SET_ECONOMIC_CALENDER_DATA, auto_chartist)
                                        if(this.upnextDate){
                                            this.upnextDate = false
                                        }
                                    }
                                }
                            }else{
                                this.filter_no_record = true
                            }
                        }*/
                    }
                    
                }else if(getcountry.length ==  0){
                    //this.selectcountrymessage = 'Please select the Country'
                    this.filter_no_record = false
                    let autoChartist = {};
                    for(let i=0 ; i<=this.responseData.length-1 ; i++){
                        const eventDate = moment(this.responseData[i].Date).format("YYYY-MM-DD")
                        if(this.upnextDate){
                            if(Date.parse(this.responseData[i].Date) < Date.now().toString()){
                                continue;
                            }
                        }
                        if(autoChartist[eventDate]){
                            autoChartist[eventDate].push(this.responseData[i])
                        }else{
                            autoChartist[eventDate] = []
                            autoChartist[eventDate].push(this.responseData[i])
                        }
                        
                        if(i == this.responseData.length-1){
                            this.$store.commit(Const.SET_ECONOMIC_CALENDER_DATA, autoChartist)
                            if(this.upnextDate){
                                this.upnextDate = false
                            }
                                
                        }
                    }
                }
            },

            getEvent(data,index,index1){
                if(data != ''){
                    if(this.eventIndex == index+'_'+index1){
                        this.eventSymbol = ''
                        this.eventIndex = ''
                        return
                    }
                    this.eventData = {}
                    this.eventSymbol = data
                    this.eventIndex = this.eventIndex = index+'_'+index1
                    let inputJson = {
                        'globalParams' : {
                            Symbol: data,
                        },
                        'localParams' : {'parameter' : this}
                    }
                    this._runGetCalenderEvent(inputJson)
                }
            }
		},
        mounted(){
            let _that =  this
            $(document).on('click', function (event) {
                if (!$(event.target).closest('.timeFilter').length) {
                    _that.timeFilter = false
                }
                if (!$(event.target).closest('.currencyFilter').length) {
                    _that.currencyFilter = false
                }
            });
        },
		created(){
            if(Object.keys(this.economicCalData).length){
                this.loaderFuncRun = '0'
            }
            this.listing()
            // console.log('api call')
			/*this._runGetEconomicCalData(
				{
					filter: {'from':this.fromDateField ,'to':this.toDateField,'priority':this.priority },
					sort: [],
					search: this.search,
					page: this.page,
					perPage: parseInt(this.pageLimit),
					offset : (new Date().getTimezoneOffset()),
					'parameter' : this 
				}
			)*/
		}
	}
</script>
<style>
    .full-child .child{
        width: 100% !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/fxView/tools/pages/economic_calendar.vue